module.exports = __webpack_public_path__ + "img/avatar-40.afd892ff.png";